import type { ReactNode } from 'react';
import FieldLabel from '@/shared/components/FieldLabel';

interface Props {
  id: string;
  label?: ReactNode;
  labelId?: string;
  tooltipId?: string;
  error?: string;
  variant?: 'uppercase' | 'plain';
  children: ReactNode;
}

export default function FormField({ id, label, labelId, tooltipId, error, variant, children }: Props) {
  return (
    <div>
      <FieldLabel htmlFor={id} label={label} labelId={labelId} tooltipId={tooltipId} variant={variant} />
      {children}
      {error && <p className="mt-2 text-xs font-semibold text-red-600">{error}</p>}
    </div>
  );
}
